var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"fedex-logo d-inline-block",style:({ height: (_vm.height + "px") }),attrs:{"src":_vm.logo,"alt":"FedEx"}})}
var staticRenderFns = []

export { render, staticRenderFns }